"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _data = _interopRequireDefault(require("./data.json"));

/* istanbul ignore file */
var propTypes = {
  data: _propTypes["default"].object
};
var defaultProps = {
  data: _data["default"]
};

function mapChildren(children) {
  return children.length > 0 && children.map(function (child, index) {
    var attr = child.attributes;

    if (child.name === 'g') {
      return /*#__PURE__*/_react["default"].createElement("g", {
        fill: attr.fill,
        key: "".concat(child.name).concat(index)
      }, child.children.length > 0 && mapChildren(child.children));
    }

    if (child.name === 'path') {
      return /*#__PURE__*/_react["default"].createElement("path", {
        stroke: attr.stroke,
        fill: attr.fill,
        key: "".concat(child.name).concat(index),
        d: attr.d
      }, child.children.length > 0 && mapChildren(child.children));
    }

    if (child.name === 'circle') {
      return /*#__PURE__*/_react["default"].createElement("circle", {
        fill: attr.fill,
        id: attr.id,
        key: "".concat(child.name).concat(index),
        cx: attr.cx,
        cy: attr.cy,
        r: attr.r,
        opacity: attr.opacity
      }, child.children.length > 0 && mapChildren(child.children));
    }

    if (child.name === 'rect') {
      return /*#__PURE__*/_react["default"].createElement("rect", {
        fill: attr.fill,
        key: "".concat(child.name).concat(index),
        x: attr.x,
        y: attr.y,
        ry: attr.ry,
        rx: attr.rx,
        transform: attr.transform,
        width: attr.width,
        height: attr.height
      }, child.children.length > 0 && mapChildren(child.children));
    }

    if (child.name === 'polyline') {
      return /*#__PURE__*/_react["default"].createElement("polyline", {
        fill: attr.fill,
        key: "".concat(child.name).concat(index),
        points: attr.points
      }, child.children.length > 0 && mapChildren(child.children));
    }

    if (child.name === 'line') {
      return /*#__PURE__*/_react["default"].createElement("line", {
        fill: attr.fill,
        key: "".concat(child.name).concat(index),
        x1: attr.x1,
        x2: attr.x2,
        y1: attr.y1,
        y2: attr.y2
      }, child.children.length > 0 && mapChildren(child.children));
    }

    if (child.name === 'polygon') {
      return /*#__PURE__*/_react["default"].createElement("polygon", {
        fill: attr.fill,
        key: "".concat(child.name).concat(index),
        points: attr.points
      }, child.children.length > 0 && mapChildren(child.children));
    }

    if (child.name === 'linearGradient') {
      return /*#__PURE__*/_react["default"].createElement("linearGradient", {
        key: "".concat(child.name).concat(index),
        id: attr.id,
        gradientUnits: attr.gradientUnits,
        x1: attr.x1,
        y1: attr.y1,
        x2: attr.x2,
        y2: attr.y2,
        gradientTransform: attr.gradientTransform
      }, child.children.length > 0 && mapChildren(child.children));
    }

    if (child.name === 'stop') {
      return /*#__PURE__*/_react["default"].createElement("stop", {
        offset: attr.offset,
        stopColor: attr['stop-color'],
        key: "".concat(child.name).concat(index)
      }, child.children.length > 0 && mapChildren(child.children));
    }
  });
}

var CreditCardIcon = function CreditCardIcon(props) {
  var data = props.data,
      name = props.name,
      inverted = props.inverted;
  var icon;
  var invertedCards = ['dinersClub', 'generic', 'placeholder', 'visa', 'securityCode', 'securityCodeAmex'];
  if (inverted && invertedCards.includes(name)) icon = data["".concat(name, "-inverted")];else icon = data[name];
  return /*#__PURE__*/_react["default"].createElement("svg", {
    data: data,
    viewBox: icon.attributes.viewBox,
    width: "100%"
  }, mapChildren(icon.children));
};

CreditCardIcon.propTypes = propTypes;
CreditCardIcon.defaultProps = defaultProps;
var _default = CreditCardIcon;
exports["default"] = _default;